import { createActionCreator } from 'utils';

const { createAction } = createActionCreator('App');

export const reset = createAction('Reset');
export const setOnboardingSteps = createAction('Set onboarding steps');
export const updateOnboardingSteps = createAction('Update onboarding steps');
